module.exports = __webpack_public_path__ + "static/media/user-oldie.a9a7a9d0.svg";